import JiraTemplate from "./JiraTemplate";

export default JiraTemplate;
